module.exports = __webpack_public_path__ + "img/3_5_1.685d9909.png";